"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const DailyViewHelpers_1 = require("./DailyViewHelpers");
const useAvailabilities_1 = __importDefault(require("../../hooks/useAvailabilities"));
const useUrlParams_1 = require("../../hooks/useUrlParams");
const BookingStatus_1 = __importDefault(require("../Other/BookingStatus"));
const ListItemContainer = styled_components_1.default.div `
  display: flex;
  margin: 1vmin;
  background-color: #f4f0ef;
  border-radius: 12px;
  overflow: hidden;
`;
const ImageWrapper = styled_components_1.default.div `
  flex: 0 0 40%;
  min-height: 95px;
  max-height: 95px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 130px;

  @media (min-width: 1080px) {
    min-height: 130px;
    max-height: 130px;
  }
`;
const ListItemDetails = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.25rem 1rem;

  @media (min-width: 1080px) {
    padding: 0.8rem 1rem;
  }

  .status-box {
    color: #5e5e5e;
    background-color: #ebe7e7;
    margin: 0;

    & > div {
      width: 15px;
      height: 15px;
    }

    p {
      font-size: 20px;
      line-height: 24px;
    }
  }
`;
const ColumnWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
const Heading1 = styled_components_1.default.h1 `
  font-size: 24px;
  font-weight: 500;
  margin: 0;
  color: #1c1b1b;
  max-height: 6rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* Number of lines to show */
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;

  &:only-child {
    margin: auto 0;
  }
`;
const TimeAndPlace = styled_components_1.default.p `
  font-size: 20px;
  line-height: 24px;
  font-weight: 400;
  margin: 0;
  color: ${({ variant }) => (variant === 'place' ? '#5E5E5E' : '#1C1B1B')};
  background-color: #ebe7e7;
  border-radius: 8px;
  padding: 0.5rem;
  margin-left: auto;
  white-space: nowrap;

  &:only-child {
    align-self: flex-start;
    margin: 0;
  }
`;
const FallbackImage = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  background-color: ${({ color }) => color};
  opacity: 60%;
`;
const ListItem = ({ item, isLast, brandInfo, timezone }) => {
    const { title, placeName, locale } = item;
    const activityTime = (0, DailyViewHelpers_1.renderActivityTime)(item, timezone);
    const image = (item && item.images && item.images[0] && item.images[0]['1:1'] && item.images[0]['1:1'].M) || '';
    const { brand, venue: urlVenue } = (0, useUrlParams_1.useUrlParams)();
    const availability = (0, useAvailabilities_1.default)(item, brand, urlVenue);
    return (react_1.default.createElement(ListItemContainer, { isLast: isLast },
        react_1.default.createElement(ImageWrapper, null, image ? (react_1.default.createElement("img", { src: image, alt: title, style: { width: '100%', height: '100%', objectFit: 'cover' } })) : (react_1.default.createElement(FallbackImage, { color: brandInfo.colorSecondary }))),
        react_1.default.createElement(ListItemDetails, null,
            react_1.default.createElement(ColumnWrapper, null,
                react_1.default.createElement(Heading1, null, title),
                availability && react_1.default.createElement(BookingStatus_1.default, { availabilityState: availability, size: 1, currentLocale: locale })),
            react_1.default.createElement(ColumnWrapper, null,
                activityTime && react_1.default.createElement(TimeAndPlace, null, activityTime),
                ' ',
                placeName && react_1.default.createElement(TimeAndPlace, { variant: "place" }, placeName),
                ' '))));
};
exports.default = ListItem;
